import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { ButtonModule } from 'primeng/button';
import {
  DialogService,
  DynamicDialogConfig,
  DynamicDialogRef
} from 'primeng/dynamicdialog';
import { InputNumberModule } from 'primeng/inputnumber';
import { ITax } from 'src/app/common/model/organization.model';
import { OrganizationService } from 'src/app/common/services/organization/organization.service';

@Component({
  standalone: true,
  selector: 'app-add-tax-setup',
  templateUrl: './add-tax-setup.component.html',
  styleUrls: ['./add-tax-setup.component.scss'],
  providers: [DialogService],
  imports: [CommonModule, FormsModule, InputNumberModule, ButtonModule]
})
export class AddTaxSetupComponent {
  tax: ITax = {
    name: '',
    percentage: 0
  };

  constructor(
    private organizationService: OrganizationService,
    public ref: DynamicDialogRef,
    public dialogService: DialogService
  ) {}

  isFormValid(): boolean {
    return !!this.tax.name && this.tax.percentage > 0 && this.tax.percentage <= 100;
  }

  createOrganizationTax(): void {
    if (this.isFormValid()) {
      this.organizationService.addOrganizationTax(this.tax).subscribe({
        next: (res) => {
          this.resetTax();
          this.ref.close(res.result);
          1;
        }
      });
    }
  }

  resetTax(): void {
    this.tax = {
      name: '',
      percentage: 0
    };
  }
}
